import { defineComponent, type SetupContext } from "vue";
import html_iway from "./template.iway.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

interface Props {
  modelValue: boolean;
  title: string;
}

export default defineComponent({
  template: html,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  emits: {
    "update:modelValue": (_value: boolean) => true,
  },
  setup(_props: Props, { emit }: SetupContext) {
    const close = () => {
      emit("update:modelValue", false);
    };

    return {
      close,
    };
  },
} as any);
